const partyOrderReducer = (state = {}, action) => {
    switch (action.type) {
      default:
        return state
    }
  };
  
  export default partyOrderReducer;